/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExportacaoEquipamentosAutorizacaoFormDto } from '../models/exportacao-equipamentos-autorizacao-form-dto';
import { ExportacaoEquipamentosCriteriaDto } from '../models/exportacao-equipamentos-criteria-dto';
import { ExportacaoEquipamentosDto } from '../models/exportacao-equipamentos-dto';
import { ExportacaoEquipamentosFormDto } from '../models/exportacao-equipamentos-form-dto';
import { ExportacaoEquipamentosPageDto } from '../models/exportacao-equipamentos-page-dto';


/**
 * Exportação de Equipamentos Geradores Radiação
 */
@Injectable({
  providedIn: 'root',
})
export class ExportacaoEquipamentosGeradoresRadiacaoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPedidosExpEquipamentos
   */
  static readonly GetPedidosExpEquipamentosPath = '/exportacao-equipamentos-geradores-radiacao';

  /**
   * Pesquisar Exportacoes Equipamentos Geradores Radia.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPedidosExpEquipamentos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidosExpEquipamentos$Response(params?: {
    criteria?: ExportacaoEquipamentosCriteriaDto;
  }): Observable<StrictHttpResponse<ExportacaoEquipamentosPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoEquipamentosGeradoresRadiacaoService.GetPedidosExpEquipamentosPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoEquipamentosPageDto>;
      })
    );
  }

  /**
   * Pesquisar Exportacoes Equipamentos Geradores Radia.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPedidosExpEquipamentos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidosExpEquipamentos(params?: {
    criteria?: ExportacaoEquipamentosCriteriaDto;
  }): Observable<ExportacaoEquipamentosPageDto> {

    return this.getPedidosExpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoEquipamentosPageDto>) => r.body as ExportacaoEquipamentosPageDto)
    );
  }

  /**
   * Path part for operation submeterExpEquipamentos
   */
  static readonly SubmeterExpEquipamentosPath = '/exportacao-equipamentos-geradores-radiacao';

  /**
   * Submeter Exportação Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterExpEquipamentos()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterExpEquipamentos$Response(params?: {
    body?: {
'expEGRForm'?: ExportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<StrictHttpResponse<ExportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoEquipamentosGeradoresRadiacaoService.SubmeterExpEquipamentosPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Submeter Exportação Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterExpEquipamentos$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterExpEquipamentos(params?: {
    body?: {
'expEGRForm'?: ExportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<ExportacaoEquipamentosDto> {

    return this.submeterExpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoEquipamentosDto>) => r.body as ExportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation getPedidoExpEquipamentos
   */
  static readonly GetPedidoExpEquipamentosPath = '/exportacao-equipamentos-geradores-radiacao/{id}';

  /**
   * Pesquisar Exportacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPedidoExpEquipamentos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoExpEquipamentos$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ExportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoEquipamentosGeradoresRadiacaoService.GetPedidoExpEquipamentosPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Pesquisar Exportacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPedidoExpEquipamentos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoExpEquipamentos(params: {
    id: number;
  }): Observable<ExportacaoEquipamentosDto> {

    return this.getPedidoExpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoEquipamentosDto>) => r.body as ExportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation updateExpEquipamentos
   */
  static readonly UpdateExpEquipamentosPath = '/exportacao-equipamentos-geradores-radiacao/{id}';

  /**
   * Editar Exportacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExpEquipamentos()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateExpEquipamentos$Response(params: {
    id: number;
    body?: {
'expEGRForm'?: ExportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<StrictHttpResponse<ExportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoEquipamentosGeradoresRadiacaoService.UpdateExpEquipamentosPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Editar Exportacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateExpEquipamentos$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateExpEquipamentos(params: {
    id: number;
    body?: {
'expEGRForm'?: ExportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<ExportacaoEquipamentosDto> {

    return this.updateExpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoEquipamentosDto>) => r.body as ExportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation updateAutorizacaoExpEquipamentos
   */
  static readonly UpdateAutorizacaoExpEquipamentosPath = '/exportacao-equipamentos-geradores-radiacao/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido exportação de equipamentos GR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacaoExpEquipamentos()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoExpEquipamentos$Response(params: {
    id: number;
    body?: ExportacaoEquipamentosAutorizacaoFormDto
  }): Observable<StrictHttpResponse<ExportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoEquipamentosGeradoresRadiacaoService.UpdateAutorizacaoExpEquipamentosPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido exportação de equipamentos GR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacaoExpEquipamentos$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoExpEquipamentos(params: {
    id: number;
    body?: ExportacaoEquipamentosAutorizacaoFormDto
  }): Observable<ExportacaoEquipamentosDto> {

    return this.updateAutorizacaoExpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoEquipamentosDto>) => r.body as ExportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoExportacaoEgr
   */
  static readonly PreviewDocAutorizacaoExportacaoEgrPath = '/exportacao-equipamentos-geradores-radiacao/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoExportacaoEgr()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoExportacaoEgr$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoEquipamentosGeradoresRadiacaoService.PreviewDocAutorizacaoExportacaoEgrPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoExportacaoEgr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoExportacaoEgr(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoExportacaoEgr$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
